(() => {
  const input = document.querySelector('[data-search-input]');
  const out = document.querySelector('[data-search-results]');
  const discover = document.querySelector('[data-search-discover]');
  const clear = document.querySelector('[data-search-clear]');
  if (!input || !out || !discover || !clear) return;
  let timer, controller;
  const root = document.body.dataset.root || '/';
  const message = text => {
    out.replaceChildren();
    const p = document.createElement('p');
    p.textContent = text;
    out.append(p);
    out.hidden = false;
  };
  const viewAll = q => {
    const link = document.createElement('a');
    link.className = 'search-view-all';
    const url = new URL(input.form.action, window.location.origin);
    url.searchParams.set('q', q);
    link.href = url.toString();
    link.textContent = 'View all results ↗';
    out.append(link);
  };
  const render = (data, q) => {
    const resources = data.resources?.results || {};
    const products = (resources.products || []).slice(0, 5);
    const groups = [['Collections', resources.collections], ['Pages', resources.pages], ['Articles', resources.articles]].filter(([, items]) => items?.length);
    out.replaceChildren();
    if (!products.length && !groups.length) {
      message('No exact match. Try a film title, a place or a mood.');
      viewAll(q);
      return;
    }
    if (products.length) {
      const heading = document.createElement('h3');
      heading.textContent = 'Products';
      out.append(heading);
      const grid = document.createElement('div');
      grid.className = 'search-product-grid';
      grid.style.setProperty('--result-columns', products.length);
      products.forEach(item => {
        const card = document.createElement('a');
        card.className = 'search-product-card';
        card.href = item.url;
        const media = document.createElement('span');
        media.className = 'search-product-media';
        const source = typeof item.image === 'string' ? item.image : item.featured_image?.url;
        if (source) {
          const img = document.createElement('img');
          img.src = source;
          img.alt = '';
          media.append(img);
        }
        const title = document.createElement('span');
        title.className = 'search-product-title';
        title.textContent = item.title;
        card.append(media, title);
        grid.append(card);
      });
      out.append(grid);
    }
    if (groups.length) {
      const related = document.createElement('div');
      related.className = 'search-related';
      groups.forEach(([title, items]) => {
        const group = document.createElement('div');
        const heading = document.createElement('h3');
        heading.textContent = title;
        group.append(heading);
        items.slice(0, 5).forEach(item => {
          const link = document.createElement('a');
          link.href = item.url;
          link.textContent = item.title;
          group.append(link);
        });
        related.append(group);
      });
      out.append(related);
    }
    viewAll(q);
    out.hidden = false;
  };
  const update = () => {
    clearTimeout(timer);
    controller?.abort();
    clear.hidden = input.value.length === 0;
    const q = input.value.trim();
    discover.hidden = q.length >= 2;
    out.hidden = true;
    out.replaceChildren();
    if (q.length < 2) return;
    timer = setTimeout(async () => {
      const request = new AbortController();
      controller = request;
      try {
        const response = await fetch(`${root}search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,collection,page,article&resources[limit]=5&resources[options][unavailable_products]=hide`, { signal: request.signal });
        if (!response.ok) throw new Error('Search unavailable');
        const data = await response.json();
        if (!request.signal.aborted && input.value.trim() === q) render(data, q);
      } catch (error) {
        if (request.signal.aborted || input.value.trim() !== q) return;
        message('Search is temporarily unavailable. Press Enter to see full results.');
      }
    }, 160);
  };
  input.addEventListener('input', update);
  input.form.addEventListener('reset', event => {
    event.preventDefault();
    input.value = '';
    update();
    input.focus();
  });
  update();
})();
